(function () {
  'use strict';

  /*
    Osservatore del dataLayer: NON invia eventi, si limita a loggare in console
    tutto quello che viene spinto nel dataLayer e il relativo payload.
    L'invio degli eventi e' responsabilita' di snippets/datalayer-events.liquid.

    Flag disponibili (da impostare prima del caricamento dello script, oppure
    da console prima di ricaricare la pagina):
      window.__dlDebug   = false  -> disattiva completamente i log
      window.__dlVerbose = true   -> logga anche gli eventi interni di GTM (gtm.*)
                                     e i reset { ecommerce: null }
  */

  var LOG_PREFIX = '[dataLayer]';
  var GTM_RESCAN_INTERVAL = 500;
  var GTM_RESCAN_DURATION = 15000;

  function isDebug() {
    return window.__dlDebug !== false && !!window.console;
  }

  function isVerbose() {
    return window.__dlVerbose === true;
  }

  // Gli entry del dataLayer possono essere oggetti, oppure un oggetto
  // "arguments" quando la pagina usa gtag().
  function normalize(entry) {
    if (entry && typeof entry === 'object' && typeof entry.length === 'number' && !Array.isArray(entry)) {
      return { gtag: Array.prototype.slice.call(entry) };
    }
    return entry;
  }

  function describe(entry) {
    if (!entry || typeof entry !== 'object') return String(entry);
    if (entry.gtag) return 'gtag(' + entry.gtag.join(', ') + ')';
    if (entry.event) return entry.event;
    if ('ecommerce' in entry && entry.ecommerce === null) return 'reset ecommerce';
    return Object.keys(entry).join(', ') || 'entry senza chiavi';
  }

  // Eventi di servizio: rumore di fondo, visibili solo in modalita' verbose.
  function isNoise(entry) {
    if (!entry || typeof entry !== 'object') return false;
    if (typeof entry.event === 'string' && entry.event.indexOf('gtm.') === 0) return true;
    return Object.keys(entry).length === 1 && 'ecommerce' in entry && entry.ecommerce === null;
  }

  function logEntry(entry, source) {
    if (!isDebug()) return;

    var normalized = normalize(entry);
    if (isNoise(normalized) && !isVerbose()) return;

    var label = LOG_PREFIX + ' ' + source + ' -> ' + describe(normalized);

    if (console.groupCollapsed) {
      console.groupCollapsed(label);
      console.log(normalized);
      console.groupEnd();
    } else {
      console.log(label, normalized);
    }
  }

  // ---- Intercettazione di dataLayer.push --------------------------------
  window.dataLayer = window.dataLayer || [];

  function install() {
    var currentPush = window.dataLayer.push;
    if (currentPush && currentPush.__dlObserver) return;

    function observedPush() {
      var args = Array.prototype.slice.call(arguments);
      args.forEach(function (entry) { logEntry(entry, 'push'); });
      return currentPush.apply(window.dataLayer, args);
    }

    observedPush.__dlObserver = true;
    window.dataLayer.push = observedPush;
  }

  // Eventi gia' in coda: lo snippet gira nell'head, quindi di norma i suoi
  // push arrivano prima di questo script (caricato con defer).
  window.dataLayer.forEach(function (entry, index) {
    logEntry(entry, 'in coda #' + index);
  });

  install();

  // GTM sostituisce dataLayer.push con il proprio handler quando si carica:
  // reinstalliamo il wrapper sopra quello di GTM per non perdere i log.
  var rescan = setInterval(install, GTM_RESCAN_INTERVAL);
  setTimeout(function () { clearInterval(rescan); }, GTM_RESCAN_DURATION);

  if (isDebug()) {
    console.log(
      LOG_PREFIX + ' observer attivo (solo log, nessun invio). ' +
      'window.__dlDebug = false per disattivarlo, window.__dlVerbose = true per vedere anche gli eventi gtm.*'
    );
  }
})();
